import React from 'react';

const VehicleDealsContext = React.createContext({ dealRecords: null });

export default VehicleDealsContext;
